import { breakpointSizes, getBreakpointDown } from '@paywithextend/components'
import { base_colorContentBorder } from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { css } from 'styled-components'

export default css`
  &.ExpenseCategoryLabelsList {
    display: flex;
    flex-direction: column;
    gap: ${spacing(5)};
    width: 100%;
    height: 100%;
    overflow: hidden;
    /* TODO: replace with generic ext-ui solution */
    ${getBreakpointDown(breakpointSizes.SM)(css`
      height: 90vh;
    `)};

    & .table-header {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: ${spacing(4)};
      padding: ${spacing(4)} ${spacing(6)};
      border-bottom: 1px solid ${base_colorContentBorder};

      & .toolbar-container {
        display: flex;
        align-items: center;
        gap: ${spacing(10)};
      }
    }
  }
`
